import {
  IntegrationTypeAWS,
  IntegrationTypeDuo,
  IntegrationTypeMimecast,
  IntegrationTypeO365,
  IntegrationTypeSentinelOne,
  IntegrationTypeWebroot,
  IntegrationTypeUmbrella,
} from "../constants";

export const cloudModuleConfigFieldLabels = {
  [IntegrationTypeDuo]: {
    secret: {
      ikey: "Duo-provided Integration Key",
      skey: "Duo-provided Secret Key",
      api_hostname: "Duo-provided API Hostname",
    },
  },
  [IntegrationTypeO365]: {
    secret: {
      client_id: "Application (client) ID",
      tenant_id: "Directory (tenant) ID",
      client_secret: 'Client Secret "Value"',
    },
  },
  [IntegrationTypeAWS]: {
    secret: {
      aws_access_key: "Access Key ID",
      aws_secret_access_key: "Secret Access Key",
      aws_region: "AWS Region",
    },
    configuration: {
      stream_name: "Stream Name",
    },
  },
  [IntegrationTypeSentinelOne]: {
    secret: {
      management_url: "Management URL",
      api_token: "API Token",
      account_id: "Account ID",
      site_id: "Site ID",
    },
  },
  [IntegrationTypeMimecast]: {
    secret: {
      management_url: "Global Base Root URL",
      app_id: "Application ID",
      app_key: "Application Key",
      access_key: "Access Key",
      secret_key: "Secret Key",
    },
  },
  [IntegrationTypeWebroot]: {
    secret: {
      client_id: "Client ID",
      client_secret: "Client Secret",
      site_name: "Site Name",
      parent_key_code: "Site Parent Keycode",
      admin_username: "Admin Username",
      admin_password: "Admin Password",
    },
  },
  [IntegrationTypeUmbrella]: {
    secret: {
      org_id: "Organization ID",
      org_key: "API Token",
      org_secret: "API Secret",
    },
  },
};
